var map = {
	"./concello.png": 4810,
	"./dc.png": 9742,
	"./dds.png": 2805,
	"./ecg.png": 1066,
	"./eci.png": 4939,
	"./elespanol.png": 8496,
	"./lvdg.png": 1569,
	"./rls.png": 6692,
	"./sygo.png": 9937
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 8116;